import React,{useState} from "react";
import {Link} from 'react-scroll';
import {FaBars,FaTimes} from 'react-icons/fa'
import './Navbar.css'
function Navbar(){
 const [icons,setIcons]=useState(false);
 const handercheck=()=>{
     setIcons(!icons)
 }
 const closemenu=()=>{
     setIcons(false)
 }
 return(
     <>
     <nav className="navbar" id="navbar">
     <Link to='home'smooth={true} duration={500} > 
         <div className='logo-cont'>
             <img src='./Assets/aj-white.png' className='logo-img' alt='Logo'/>
             <p className='logo-hover'>Jeeva<br/> <span>-web developer-</span></p>
         </div>
         </Link>
            <div className="nav-icon" onClick={handercheck}>
             {
                icons ? <FaTimes className="fa-times"></FaTimes> : <FaBars className="fa-bars"></FaBars>
             }
             </div>
         <ul className={
             icons ? 'nav-menu active':
             'nav-menu'
         }>
             <li className='nav-li'>
             <Link to ='about' smooth={true} duration={500}className="navbar-li" onClick={closemenu}>About</Link>
             </li>
             <li className='nav-li'>
             <Link to ='portfolio'  smooth={true} duration={500} className="navbar-li center" onClick={closemenu}>Portfolio</Link>
             </li>
             <li className='nav-li'>
             <Link to ='contact' smooth={true} duration={500} className="navbar-li" onClick={closemenu}>Contact</Link>
             </li>
         </ul>
     </nav>
     </>
 )
}
export default Navbar;
